const state = () => ({
    operation: 'add',
    list:[],
    item: {},
    index: null,
})

const getters = {

}

const actions = {
    loadList({ commit },list){
        commit('SET_LIST', list)
    },
    setCurrentItem({ commit },item){
        commit('SET_CURR_ITEM', item)
    },
    setIndex ({ commit },index) {
        commit('SET_INDEX', index)
    },
    switchOnUpdate ({ commit,state,dispatch },item) {
        const index = state.list.findIndex(x => x === item)
        dispatch('setIndex',index)
        dispatch('setCurrentItem',item)
        commit('OPERATION', 'update')
    },
    switchOnAdd ({ commit, dispatch }) {
        dispatch('setIndex', null)
        dispatch('setCurrentItem', {})
        commit('OPERATION', 'add')
    },
}

const mutations = {
    OPERATION (state, value) {
        state.operation = value
    },
    SET_LIST(state,value){
        state.list = value
    },
    SET_INDEX(state,value){
        state.index = value
    },
    SET_CURR_ITEM(state,value){
        state.item = value
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
